/* istanbul ignore file */

export { OpenJobsHighlight as default } from "./OpenJobsHighlight";
